import { api } from "@/lib/api";

// Detección de entorno y alta de avisos push (Web Push estándar, sin servicios de pago).
const ua = () => navigator.userAgent || "";
export const isIOS = () => /iPad|iPhone|iPod/.test(ua()) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isAndroid = () => /Android/i.test(ua());
export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOSNoSafari = () => isIOS() && /CriOS|FxiOS|EdgiOS|OPiOS|GSA\/|FBAN|FBAV|Instagram|Line\/|WhatsApp|YaBrowser|DuckDuckGo/i.test(ua());
export const iosVersion = () => {
  const m = ua().match(/OS (\d+)_(\d+)/);
  return m ? parseFloat(`${m[1]}.${m[2]}`) : null;
};
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const permiso = () => ("Notification" in window ? Notification.permission : "unsupported");
export const plataforma = () => (isIOS() ? "ios" : isAndroid() ? "android" : "otro");

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const registrarSW = () =>
  "serviceWorker" in navigator ? navigator.serviceWorker.register("/sw.js").catch(() => null) : Promise.resolve(null);

export const endpointActual = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub ? sub.endpoint : null;
};

// Debe llamarse directamente desde un toque del usuario (Apple lo exige).
export const activarAvisos = async () => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, perm };
  await registrarSW();
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/config");
  const key = b64ToUint8(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    const actual = sub.options?.applicationServerKey;
    if (actual && btoa(String.fromCharCode(...new Uint8Array(actual))) !== btoa(String.fromCharCode(...key))) {
      await sub.unsubscribe();
      sub = null;
    }
  }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    plataforma: plataforma(), instalada: isStandalone(),
  });
  return { ok: true, perm, endpoint: sub.endpoint };
};

export const probarAviso = async () => api.post("/push/test", { endpoint: await endpointActual() });
export const estadoServidor = async () => (await api.get("/push/estado", { params: { endpoint: await endpointActual() } })).data;
